/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '@brochington/ecstatic';
import { Matrix4 } from '@math.gl/core';
import { Components } from 'editor/components';
import MapboxCanvasSource from 'editor/components/map/MapboxCanvasSource';
import MapboxMap from 'editor/components/map/MapboxMap';
import MapboxOverlay from 'editor/components/map/MapboxOverlay';
import Transform from 'editor/components/Transform';
import {
  createMercatorMatrix,
  sourceCoordsToImageAlignment,
} from 'editor/utils/map';

export const manageOverlayComponents = [
  MapboxMap,
  MapboxOverlay,
  MapboxCanvasSource,
  Transform,
];

// I kinda want to rename this....
export function manageOverlay(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const sourceComp = components.get(MapboxCanvasSource);
  const mapComp = components.get(MapboxMap);
  const transformComp = components.get(Transform);

  const sourceCanvas = sourceComp.getCanvas();
  const { height: sourceHeight, width: sourceWidth } = sourceCanvas;

  // bottom left origin transform
  const nextMat = new Matrix4().identity();

  // sheet transform
  const imageSource = sourceComp.getSource();
  const { coordinates } = imageSource;
  if (!coordinates) return;
  if (!mapComp.map) return;

  const { map } = mapComp;
  // @ts-ignore
  const { transform } = map;
  const { worldSize, pixelMatrix } = transform;

  const coords = sourceCoordsToImageAlignment(coordinates);
  const mercatorMatrix = createMercatorMatrix(
    coords,
    sourceWidth,
    sourceHeight,
    worldSize
  );

  // QUESTION: Why doesn't the matrix need to be set to a bottom left origin?
  //           Is this already happening somewhere?
  // prettier-ignore
  // nextMat.multiplyLeft(new Matrix4([
  //   1,  0,      0,  0,
  //   0, -1,      0,  0,
  //   0,  0,      1,  0,
  //   0,  sourceHeight, 0,  1,
  // ]));
  nextMat.multiplyLeft(mercatorMatrix);
  nextMat.multiplyLeft(pixelMatrix);
  nextMat.multiplyScalar(1 / nextMat[15]);

  transformComp.transform = nextMat;
}
